import { WORD_COUNT } from './countSpecific'

export const WORD_LENGTH = 5
export const MAX_WORD_LENGTH = WORD_LENGTH * WORD_COUNT
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 250
export const GAME_LOST_INFO_DELAY = (MAX_WORD_LENGTH + 1) * REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
